import "./OperationStageOverlay.sass"
import AdsbStageOsd from './AdsbStageOsd/AdsbStageOsd'
import { StageElement } from '../../OperationDashboard'
import { DockVideoSourceDevice } from '../DockCamera/DockCamera'
import FlightAuthorityStageOsd from "./FlightAuthorityStageOsd/FlightAuthorityStageOsd"
import SignalStageOsd from "./SignalStageOsd/SignalStageOsd"

function OperationStageOverlay({ entity, activeDockVideoSource, stageSplitted = false }) {
  return (
    <div className="operation-stage-overlay" style={{
      top: stageSplitted ? activeDockVideoSource !== DockVideoSourceDevice.DOCK ? '115px' : '60px' : '12px', 
      left: stageSplitted ? '10px' : '60px'
    }}>
      <FlightAuthorityStageOsd entity={entity} stageSplitted={stageSplitted} />
      <SignalStageOsd entity={entity} stageSplitted={stageSplitted} />
      <AdsbStageOsd entity={entity} />
    </div>
  )
}

export default OperationStageOverlay